import React from 'react';
import '../../styles/SessionWarning.css';

function SessionWarningModal({
  remainingSeconds,
  onExtend,
  onLogout
}) {
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    if (mins > 0) {
      return `${mins}:${secs.toString().padStart(2, '0')}`;
    }
    return `${secs} segundos`;
  };

  return (
    <div className="session-warning-overlay">
      <div className="session-warning-modal">
        <div className="session-warning-icon">
          <svg viewBox="0 0 24 24" width="48" height="48" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <polyline points="12,6 12,12 16,14"/>
          </svg>
        </div>

        <h3>Sesion por expirar</h3>

        <p className="session-warning-message">
          Su sesion se cerrara automaticamente por inactividad en:
        </p>

        <div className="session-warning-countdown">
          {formatTime(remainingSeconds)}
        </div>

        <p className="session-warning-question">
          Desea continuar trabajando?
        </p>

        <div className="session-warning-actions">
          <button
            className="btn-session-extend"
            onClick={onExtend}
            autoFocus
          >
            Continuar sesion
          </button>
          <button
            className="btn-session-logout"
            onClick={onLogout}
          >
            Cerrar sesion
          </button>
        </div>
      </div>
    </div>
  );
}

export default SessionWarningModal;
